import classnames from 'classnames';
import React from 'react';
import { setElementAttributes, Translations } from '../../../utils';
import FormButton from '../Btn';
import Tooltip from '../Tooltip';

import './inputTextbox.css';

class InputTextbox extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      inputInValid: undefined,
      inputValue: '',
      validationMsg: '',
      showTooltip: false,
      flag: '',
      toggleCheck: false,
    };
  }

  componentDidMount() {
    this.setState({ inputValue: this.props._value || '' });
    if (this.props.name === 'registeredName' || this.props.name === 'hsbcEntity' || (this.props.name === 'eChannelId' && this.props.setEchanelBtn)) {
      if (!(this.props.properties.mode === "edit" && this.props.properties.productType === "gls-sow-create-entity")) {
        this.nameInput.focus();
      }
    }
    if (this.props._value && this.props._value !== '' && this.props.name === 'eChannelId') {
      this.setInputAsValid(this.props.name);
    }
    if (this.props._value && this.props._value !== '' && this.props.name === 'csProjectNumber') {
      if (this.props._value.length !== 10) {
        this.setInputAsInValid(this.props.name, this.props.regexValidationMessage);
      }
    }
    if (this.props._value && this.props._value !== '' && this.props.name === 'cmpProjectID') {
      if (this.props._value.length !== 9) {
        this.setInputAsInValid(this.props.name, this.props.regexValidationMessage);
      }
    }
    if (this.props.name === "CaseID") {
      let propsForCheckAvailability = {
        translatedText: this.props.CheckAvailabilityProps ? Translations(this.props.CheckAvailabilityProps.text, this.props.lang, this.props.translatedData) : '',
        bsClass: "gdocs-btn-CheckAvailability",
        id: "manual_case-button_checkAvailability"
        // disabled : this.props.CheckAvailabilityProps.disabled
      }
      let propsForSearch = {
        translatedText: this.props.SearchProps ? Translations(this.props.SearchProps.text, this.props.lang, this.props.translatedData) : '',
        bsClass: "gdocs-btn-Search",
        id: "manual_case-button_search"
        //disabled : this.props.SearchProps.disabled
      }
      this.setState({
        propsForCheckAvailability,
        propsForSearch
      })
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps._value !== this.props._value) {
      this.setState({ inputValue: nextProps._value });
    }
    if (this.props.flag !== undefined && nextProps.flag !== this.props.flag) {
      if (this.props.name === 'csProjectNumber' || this.props.name === 'cmpProjectID') {
        if (this.state.inputValue === '' || this.state.inputValue === undefined) {
          this.setInputAsValid(this.props.name);
        }
      }
    }
    if (this.props.properties !== undefined && this.props.properties.editType === "add-manual-case-basic-details") {
      if (nextProps.CaseRecordToggle !== undefined || nextProps.ResetForm !== undefined) {
        if (nextProps.CaseRecordToggle !== this.props.CaseRecordToggle || nextProps.ResetForm !== this.props.ResetForm) {
          this.setState({ inputValue: "" });
          this.props.setInputvalue("", this.props.name);
          this.setInputAsValid(this.props.name);
        }
      }
      if (nextProps.resetData !== undefined) {
        if (nextProps.resetData !== this.props.resetData) {
          nextProps._value !== "" || nextProps._value !== undefined ? this.setInputAsValid(this.props.name) : '';
          this.setState({ inputValue: nextProps._value || "" })
          this.props.setInputvalue(nextProps._value || "", this.props.name);
        }
      }
      if (nextProps.CreateNewToggle !== undefined) {
        if (nextProps.CreateNewToggle !== this.props.CreateNewToggle) {
          if (this.props.name === "CaseID" || this.props.name === "registeredName") {
            this.setState({ inputValue: nextProps._value });
            this.props.setInputvalue(nextProps._value, this.props.name);
            this.setInputAsValid(this.props.name);
          } else if (this.props.name === "txtGRIDno" || this.props.name === "csProjectNumber") {
            this.setState({ inputValue: "" });
            this.props.setInputvalue("", this.props.name);
            this.setInputAsValid(this.props.name);
          }
        }
      }
      if (this.props.msaCasesProps.isMsaCase !== nextProps.msaCasesProps.isMsaCase) {
        this.validateMsaCase(nextProps.name, nextProps._value, nextProps.msaCasesProps.isMsaCase)
      }
    }

  }

  checkValidity() {
    if (this.props.name === 'CaseID') {
      if (this.props.flagCheck !== this.state.flag) {
        if (this.props.displayError !== undefined) {
          if (this.props.displayError === true) {
            this.setInputAsInValid(this.props.name, this.props.mandatoryMessage)
          }
          else if (this.props.displayError === false) {
            this.setInputAsValid(this.props.name)
          }
        }
        this.setState({ flag: this.props.flagCheck })
      }
    } else {
      return this.state.inputInValid
    }
  }


  handleInputChange = (e) => {
    this.setState({ displayError: undefined })
    this.validateInput(e);
    this.setState({ inputValue: e.target.value });
    this.props.setInputvalue(e.target.value, e.target.name);
    if (this.props.properties !== undefined && this.props.properties.editType === "add-manual-case-documentation-details") {
      this.props.setSelectedOptions(e.target.value, e.target.name);
    }
  }

  setInputAsValid = (fieldName) => {
    this.setState({ inputInValid: false });
    this.props.setFieldValidtionState(fieldName, "valid");
  }

  setInputAsInValid = (fieldName, validationMsg) => {
    this.setState({ inputInValid: true, validationMsg });
    this.props.setFieldValidtionState(fieldName, "invalid");
  }

  validateInput = (event) => {
    const value = event.target.value;

    // mandatory validation for input when set mandatory
    if (this.props.mandatory === "true") {
      // basic input validation
      if (value !== "") {
        if (event.target.name === 'csProjectNumber') {
          if (value.length !== 10) {
            this.setInputAsInValid(event.target.name, this.props.regexValidationMessage);
          } else {
            this.props.setFieldValidtionState('csProjectNumber', 'valid');
            this.setInputAsValid(event.target.name);
          }
        }
        else {
          this.setInputAsValid(event.target.name);
        }
      } else {
        this.setInputAsInValid(event.target.name, this.props.mandatoryMessage);
      }
    }

    // regex validation for input when regex is set
    if (value !== "" && this.props.regexPattern) {
      if (event.target.name === 'csProjectNumber' || event.target.name === "cmpProjectID") {
        if (event.target.name === 'csProjectNumber' && value.length !== 10) {
          this.props.setFieldValidtionState(event.target.name, 'invalid');
        } else {
          if (new RegExp(this.props.regexPattern).test(value)) {
            this.setInputAsValid(event.target.name);
            this.props.setFieldValidtionState(event.target.name, 'valid');
          } else {
            this.setInputAsInValid(event.target.name, this.props.regexValidationMessage);
          }
        }
      }
      else if (this.props.msaCasesProps.isMsaCase && event.target.name === 'CaseID') {
        this.validateMsaCase(event.target.name, value, this.props.msaCasesProps.isMsaCase)
      }
      else {
        if (new RegExp(this.props.regexPattern).test(value)) {
          if (event.target.name === 'CaseID') {
            // document.getElementsByClassName('search-buttons-section')[0].childNodes[0].childNodes[1].disabled = false
            // document.getElementsByClassName('search-buttons-section')[0].childNodes[0].childNodes[0].disabled = false
            if (document.getElementById("manual_case-button_checkAvailability")) {
              document.getElementById("manual_case-button_checkAvailability").disabled = false
            }
            if (document.getElementById("manual_case-button_search")) {
              document.getElementById("manual_case-button_search").disabled = false
            }
          }
          this.setInputAsValid(event.target.name);
        } else {
          this.setInputAsInValid(event.target.name, this.props.regexValidationMessage);
          if (document.getElementById("manual_case-button_checkAvailability")) {
            document.getElementById("manual_case-button_checkAvailability").disabled = true
          }
          if (document.getElementById("manual_case-button_search")) {
            document.getElementById("manual_case-button_search").disabled = true
          }
        }
      }

    } else if (this.props.mandatory !== "true" && value === "" && this.props.regexPattern) {
      this.setInputAsValid(event.target.name);
    }

    // this is an on blur activity which sets pre-populated value back to formData, only done when required
    if (this.props.name === 'registeredName') {
      this.props.setInputvalue(event.target.value, event.target.name);
    }
  }

  handleManualCaseSearchButton = (disabled) => {
    if (disabled) {
      setElementAttributes("manual_case-button_checkAvailability", { disabled: true })
      setElementAttributes("manual_case-button_search", { disabled: true })
    } else {
      setElementAttributes("manual_case-button_checkAvailability", { remove: ["disabled"] })
      setElementAttributes("manual_case-button_search", { remove: ["disabled"] })
    }
  }

  validateMsaCase = (targetName, value, isMsaCase) => {
    const regexpPatternAlphabet = "^(?=.*[a-zA-Z])"
    if (targetName === 'CaseID' && value) {
      if (isMsaCase) {
        if (new RegExp(this.props.msaCasesProps.regexPatternMsaCase).test(value) && !(new RegExp(regexpPatternAlphabet).test(value))) {
          this.setInputAsValid(targetName);
          this.handleManualCaseSearchButton()
        } else {
          this.setInputAsInValid(targetName, this.props.regexValidationMessage);
          this.handleManualCaseSearchButton(true)
        }
      }
      else {
        if (new RegExp(this.props.regexPattern).test(value)) {
          this.setInputAsValid(targetName);
          this.handleManualCaseSearchButton()
        } else {
          this.setInputAsInValid(targetName, this.props.regexValidationMessage);
          this.handleManualCaseSearchButton(true)
        }
      }
    }
  }

  handleEnterKey = (e) => {
    if (e.keyCode === 13)
      e.preventDefault();
  }
  isNumber = (evt) => {
    if (this.props.name === 'csProjectNumber' || this.props.name === 'cmpProjectID') {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
      return true;
    }
  }

  toggleTooltiponEnter = (event) => {
    if (event.keyCode === 27) {
      var selector = `[data-tooltip=${this.props.id}]`
      document.querySelectorAll(selector)[0].setAttribute("aria-expanded", false)
      this.setState({
        showTooltip: false
      })
    }
  }

  toggleTooltip = () => {
    var selector = `[data-tooltip=${this.props.id}]`
    document.querySelectorAll(selector)[0].setAttribute("aria-expanded", !this.state.showTooltip)
    this.setState({
      showTooltip: !this.state.showTooltip
    })
  }
  isEdgeBrowser = () => {
    return /Edg/.test(navigator.userAgent);
  }

  render() {
    const inputErrorCss = classnames({
      "gdocs-input-error": this.checkValidity()
    });
    return (
      <div className={this.props.name === "CaseID" && this.props.msaCasesProps.jsx ? "msaCasesInputContainer" : ''}>

        <div className={classnames("input-text-container", { "input-flex-col": this.props.name === 'cmpProjectID' || this.props.name === 'csProjectNumber' })}>
          <div className={classnames({ "input-text-prefix-wrapper": this.props.inputPrefix, "error": inputErrorCss })}>
            <span className="prefix">{this.props.inputPrefix}</span>
            <input type="text"
              className={inputErrorCss}
              name={this.props.name}
              id={this.props.id}
              value={this.state.inputValue}
              minLength={this.props.min}
              maxLength={this.props.max}
              onChange={this.handleInputChange}
              onBlur={this.validateInput}
              readOnly={this.props.disabled}
              disabled={((this.props.properties !== undefined && this.props.properties.editType === "add-manual-case-basic-details" ? this.props.disabled : undefined) || this.props.disabled)}
              aria-labelledby={`${this.props.name}hint`}
              aria-describedby={`${this.props.name}-error`}
              ref={(input) => { this.nameInput = input }}
              onKeyPress={this.isNumber}
              placeholder={this.props.placeholder}
              autoComplete={this.isEdgeBrowser && (this.props.name === 'eChannelId' || this.props.name === 'eChannelIdOptional' || this.props.name === 'swiftBIC' || this.props.name === 'otherProfileOwner' || this.props.name === 'apiProfileId') ? "off" : null}
            /> {this.props.name === 'csrAppliedInterestEarnings' || this.props.name === 'csrAppliedInterestCharges' ? '%' : ''}
            <span className={this.props.name === "CaseID" && this.props.msaCasesProps.jsx ? `gdocs-display-none input-suffix-sign` : "input-suffix-sign"}>{this.props.suffixSign}</span>
          </div>
          {
            (this.props.tooltipText !== undefined && this.props.tooltipText !== "")
              ? <button type="button"
                onMouseEnter={this.toggleTooltip}
                onMouseLeave={this.toggleTooltip}
                onClick={this.toggleTooltip}
                onKeyUp={(event) => this.toggleTooltiponEnter(event)}
                className="icon icon-circle-help gdocs-valign-middle gdocs-mleft-5 hintText-icon"
                data-tooltip={this.props.id}
                style={{
                  background: "white",
                  border: "inherit"
                }}
                aria-label={`More information on ${this.props.name}`}
                aria-expanded={false}
                aria-describedby={`${this.props.name}tooltip`}
              >
              </button>
              : ''
          }

          {
            (this.props.helpText !== undefined && this.props.helpText !== "") ? (
              <div className="input-help-msg-section" id={`${this.props.name}hint`}>
                {Translations(this.props.helpText, this.props.lang, this.props.translatedData)}
              </div>
            ) : ''
          }

          <span className="gdocs-error-message error-message__inputTextbox" id={`${this.props.name}-error`} role="alert">
            {this.state.inputInValid ? (
              <React.Fragment>
                <i className="icon icon-circle-delete-solid" aria-hidden="true"></i>
                {Translations(this.state.validationMsg, this.props.lang, this.props.translatedData)}
              </React.Fragment>
            ) : ''}
          </span>
        </div>

        <Tooltip
          active={this.state.showTooltip}
          position="right"
          arrow="center"
          parent={this.props.id}
        >
          <div className="tooltip-content-hintText" id={`${this.props.name}tooltip`}>
            <span role="status" id={`${this.props.name}tooltip`}>{this.props.tooltipText !== undefined ? Translations(this.props.tooltipText, this.props.lang, this.props.translatedData) : ''}</span>
          </div>
        </Tooltip>
        {this.props.name === "CaseID" && this.props.msaCasesProps.jsx}
        {this.props.name === "CaseID" ?
          <div key="buttons-wrapper" className="search-buttons-section">
            <div className={this.props.name === "CaseID" && this.props.msaCasesProps.jsx ? `search-buttons-wrapper position-relative right-0` : "search-buttons-wrapper"}>
              <FormButton {...this.state.propsForCheckAvailability} key={"CheckAvailability"} _onClick={this.props.onCheckAvailability} />
              <FormButton {...this.state.propsForSearch} key={"manual_case-button_search"} _onClick={this.props.onSearch} />
            </div>
          </div>
          : ''} </div>
    )
  }
}

export default InputTextbox;



// WEBPACK FOOTER //
// ./src/components/common/InputBox/inputTextbox.js